import {FiltersMobileButtonDefaultBox} from "./filters-mobile-button.default.box";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {FiltersMobileButtonCasino777Box} from "./filters-mobile-button.casino777.box";
import {FiltersMobileButtonMrGreenBox} from "./filters-mobile-button.mrgreen.box";

export const FiltersMobileButtonBox = styledByTheme(FiltersMobileButtonDefaultBox)
    .forCasino777(FiltersMobileButtonCasino777Box)
    .forMrGreen(FiltersMobileButtonMrGreenBox).apply();